export default __webpack_public_path__ + "static/media/dr_karl.83889ad7.jpg";